import { render, staticRenderFns } from "./LeadEmailSettings.vue?vue&type=template&id=c37aa828&scoped=true&"
import script from "./LeadEmailSettings.vue?vue&type=script&lang=js&"
export * from "./LeadEmailSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c37aa828",
  null
  
)

export default component.exports